const Space = () => <span>&nbsp;</span>;
export { Space };
